import { useContext } from 'react';
import { ExpressCheckoutButtonsContext } from './ExpressCheckoutButtonsContext';
export const useExpressCheckoutButtonsData = () => {
  return useContext(ExpressCheckoutButtonsContext);
};
//# sourceMappingURL=useExpressCheckoutButtonsData.js.map